<template>
  <div>
    <transition name="t-translate__right">
      <div class="info u-w2of8 u-bg-grey u-full-height u-pad-y-md u-pointer-all" v-if="isVisible">
        <div class="u-row u-marg-b-md u-pad-x-lg u-middle">

          <!-- ARROW LEFT -->
          <div class="u-w1of8">
            <div class="info__btn">
              <div class="u-box-1by1" @click="$emit('onPrev')">
                <svg class="info__btn__svg t-icon t-icon--lg u-stroke-white u-fill-transparent u-fit-cover u-wrapper-panel">
                  <use xlink:href="#icon-arrrow-left"/>
                </svg>
                <svg class="info__btn__svg info__btn__svg--hover t-icon t-icon--lg u-stroke-black u-fill-transparent u-fit-cover u-wrapper-panel u-bg-white u-cursor-pointer">
                  <use xlink:href="#icon-arrrow-left"/>
                </svg>
              </div>
            </div>
          </div>

          <!-- TITLE -->
          <div class="u-w6of8 u-center t-h1 u-white u-uppercase">
            Auditorium
          </div>

          <!-- ARROW RIGHT -->
          <div class="u-w1of8">
            <div class="info__btn">
              <div class="u-box-1by1" @click="$emit('onNext')">
                <svg class="info__btn__svg t-icon t-icon--lg u-stroke-white u-fill-transparent u-fit-cover u-wrapper-panel">
                  <use xlink:href="#icon-arrrow-right"/>
                </svg>
                <svg class="info__btn__svg info__btn__svg--hover t-icon t-icon--lg u-stroke-black u-fill-transparent u-fit-cover u-wrapper-panel u-bg-white u-cursor-pointer">
                  <use xlink:href="#icon-arrrow-right"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div class="info__events u-white u-pad-md">
          <div class="t-h2">
             {{ $t('auditorium.nextEvent') }}
          </div>
          <div class="u-pad-t-sm">
            <div v-for="event in events" class="u-marg-t-md">
              <a href="" target="_blank" class="info__events__wrapper u-block u-box-16by9 u-overflow-hidden">
                <img :src="event.image" class="u-wrapper-panel u-fit-cover">
              </a>
            </div>
          </div>
        </div>

        <div class="u-pad-md">
          <app-button :ghost="true" url="https://hubs.mozilla.com/scenes/fAxGUGE">
            {{ $t('auditorium.enter') }}
          </app-button>
        </div>


        <div class="info__bottom u-row u-evenly u-bg-grey u-middle">
          <!-- Share -->
          <div class="info__bottom__item u-w1of7">
            <div class="u-flex u-center u-full-width u-pad-b-xs">
              <div class="u-w3of8">
                <div class="info__bottom__item__svg u-box-1by1">
                  <svg class="u-wrapper-panel u-fit-cover u-fill-white t-icon u-fit-cover u-cursor-pointer">
                    <use xlink:href="#icon-share"/>
                  </svg>
                </div>
              </div>
            </div>
            <div class="u-center u-full-width t-text t-text--big u-bold u-marg-t-sm u-white">
              {{ $t('district.share') }}
            </div>
          </div>
          <!-- Help -->
          <div class="info__bottom__item u-w1of7">
            <div class="u-flex u-center u-full-width u-pad-b-xs">
              <div class="u-w3of8">
                <div class="info__bottom__item__svg u-box-1by1">
                  <svg class="u-wrapper-panel u-fit-cover u-fill-white t-icon u-fit-cover u-cursor-pointer">
                    <use xlink:href="#icon-help"/>
                  </svg>
                </div>
              </div>
            </div>
            <div class="u-center u-full-width t-text t-text--big u-bold u-marg-t-sm u-white">
              {{ $t('district.help') }}
            </div>
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Vector2, Vector3 } from 'three'
import gsap from 'gsap'

import { webGL } from '@/webGL/WebGL'
import { VirtualScroll } from '@/utils/VirtualScroll'
import { CameraControl } from '@/utils/CameraControl'

export default {
  props: {
    cameraPos: {
      type: Object,
      default: () => {return new Vector3()}
    }
  },

  data() {
    return {
      isVisible: false,
      events: [
        {
          image: '/images/event1.jpg'
        },
        {
          image: '/images/event2.jpg'
        }
      ]
    }
  },

  computed: {
    data () {
      return this.$store.getters['data/auditorium']
    }
  },

  created () {
    this.pos = new Vector2()
    this.currentPos = new Vector2()

    this.virtualScroll = new VirtualScroll()

    this.virtualScroll.onPrev(()=>{
      this.$router.push(this.$local('city'))
    })

  },

  mounted () {
    gsap.to(webGL.camera.position, {
      x: this.data.cameraPos.x,
      y: this.data.cameraPos.y,
      z: this.data.cameraPos.z,
      duration: 3,
      ease: 'power4.inOut',
      onComplete: () => {
        this.isCameraFree = true
      }
    })

    gsap.to(webGL.camera.look, {
      x: this.data.look.x,
      y: this.data.look.y,
      z: this.data.look.z,
      duration: 3,
      ease: 'power4.inOut'
    })

    setTimeout(()=>{
      this.isVisible = true
    }, 2000)
  },

  methods: {
    onMousemove (event) {
      let pos = this.$device.getPointerPosition(event)
      this.pos = new Vector2(( pos.x / this.$device.width ) * 2 - 1, - ( pos.y / this.$device.height ) * 2 + 1)
    },
    onUpdate () {
      if (this.isCameraFree && this.data) {
        this.currentPos.x += (this.pos.x - this.currentPos.x) * .01
        this.currentPos.y += (this.pos.y - this.currentPos.y) * .01

        webGL.camera.position.x = this.data.cameraPos.x + this.currentPos.x * 5
        webGL.camera.position.y = this.data.cameraPos.y + this.currentPos.y * 5

        webGL.camera.forceUpdateLook = true
      }
    }
  },

  beforeDestroy () {
    this.isCameraFree = false
    this.isVisible = false
    this.virtualScroll.onDestroy()

    gsap.killTweensOf(webGL.camera.position, 'x,y,z')
    gsap.killTweensOf(webGL.camera.look, 'x,y,z')
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/settings/variables'

.info
  position absolute
  top 0
  right 0
  
  &__btn
    border solid 2px $colors.white
    border-radius 50%
    overflow hidden
    
    &__svg
      padding 25%
      
      &--hover
        opacity 0
        transition opacity .3s linear
    
    &:hover &__svg--hover 
      opacity 1
      
  &__events

    &__wrapper
      border-radius 17px
  
  &__bottom
    position absolute
    bottom 0
    left 0
    Width 100%
    height 100px
    
    &:before 
      content ''
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      box-shadow: 0px -5px 20px 0px $colors.white
      opacity .1
      pointer-events none
    
    &__item
      cursor pointer

      &__svg
        &:after
          border-radius 2px
          position absolute
          top calc( 100% + 3px )
          left 0
          width 100%
          content ''
          height 3px
          background $colors.white
</style>